var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconeMais(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 79,
    viewBox: "0 0 81 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.481 0.75C18.2787 0.75 0.259491 18.11 0.259491 39.5C0.259491 60.89 18.2787 78.25 40.481 78.25C62.6833 78.25 80.7025 60.89 80.7025 39.5C80.7025 18.11 62.6833 0.75 40.481 0.75ZM56.5696 43.375H44.5032V55C44.5032 57.1312 42.6932 58.875 40.481 58.875C38.2688 58.875 36.4589 57.1312 36.4589 55V43.375H24.3924C22.1802 43.375 20.3703 41.6312 20.3703 39.5C20.3703 37.3688 22.1802 35.625 24.3924 35.625H36.4589V24C36.4589 21.8687 38.2688 20.125 40.481 20.125C42.6932 20.125 44.5032 21.8687 44.5032 24V35.625H56.5696C58.7818 35.625 60.5918 37.3688 60.5918 39.5C60.5918 41.6312 58.7818 43.375 56.5696 43.375Z",
    fill: "#8C9199"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconeMais);
export default __webpack_public_path__ + "static/media/icone_mais.68f45c80b6bd8b4468eae524bada94ac.svg";
export { ForwardRef as ReactComponent };